(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aquafeaturedproducts"] && !Shopify.designMode) return;
  try {
    
// 兼容主题全局AJAX加购逻辑
document.querySelectorAll('.aqua-add-form').forEach(form => {
  form.addEventListener('submit', function(e) {
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.ajaxCart) {
      e.preventDefault();
      const formData = new FormData(this);
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      }).then(res => res.json()).then(() => {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
